// @flow
import { call, put, takeLatest } from 'redux-saga/effects';

import { nodes as nodesApi } from '~/core/api';
import handleApi from '~/core/state/handle-api';
import handleSaga from '~/core/state/handle-saga';

import { UPDATE_CAMERA_SETTINGS } from './constants';
import { cameraSettingsUpdated } from './actions';

import type { Effect } from 'redux-saga';
import type { Action } from '~/core/types';

type UpdateCameraParams = Action<{ cameraId: string, data: Object }>;
export function* updateCameraSettingsSaga({
    payload: { cameraId, data }
}: UpdateCameraParams): Generator<Effect, *, *> {
    const [, error] = yield call(handleApi(nodesApi.patchNode), data, 'hivecamera', cameraId);

    if (error) {
        yield put(cameraSettingsUpdated(error));
    }

    yield put(cameraSettingsUpdated({ data, cameraId }));
}

function* watchUpdateCameraSettings(): Generator<Effect, *, *> {
    yield takeLatest(UPDATE_CAMERA_SETTINGS, handleSaga(updateCameraSettingsSaga));
}

export default [watchUpdateCameraSettings];



// WEBPACK FOOTER //
// ./src/core/state/camera/sagas.js